import React, { useEffect } from 'react'

import InputFileReader from '../../components/shared/InputFileReader'

import Metadata from './Metadata'
import Messages from './Messages'

import SpreadsheetTabs from './SpreadsheetTabs'
import SpreadsheetTable from './SpreadsheetTable'

import './upload-whitelist.scss'

const UploadWhitelist = (props) => {
  const {
    parseSpreadsheetData,
    invalidAgencyCodesData,
    invalidEmailData,
    duplicateEmailData,
    isIdle,
    isValidating,
    isReady,
    isUploading,
    totalRows,
    invalidRows,
    isSuccess,
    isError,
    lastSuccessCount,
  } = props

  useEffect(() => {
    if (isReady && totalRows > 0 && invalidRows <= 0) {
      props.uploadSpreadsheetData()
    }
  }, [isReady, totalRows, invalidRows])

  return (
    <div className="fileReaderContainer">
      <h3>Upload broker emails for sign-up access</h3>
      <InputFileReader onFileLoad={parseSpreadsheetData}>
        <Metadata
          totalRows={totalRows}
          invalidRows={invalidRows}
          isIdle={isIdle}
          isReady={isReady}
          isValidating={isValidating}
          isUploading={isUploading}
        />
        <Messages.MimeTypeError />
        <Messages.InvalidDataWarning invalidRows={invalidRows} />
        <Messages.UploadSuccess
          isSuccess={isSuccess}
          lastSuccessCount={lastSuccessCount}
        />
        <Messages.UploadError isError={isError} />
      </InputFileReader>

      <SpreadsheetTabs noRender={invalidRows <= 0}>
        <SpreadsheetTable
          title="Invalid Agency Codes"
          eventKey={1}
          data={invalidAgencyCodesData}
        />
        <SpreadsheetTable title="Invalid Emails" eventKey={2} data={invalidEmailData} />
        <SpreadsheetTable
          title="Duplicate Emails"
          eventKey={3}
          data={duplicateEmailData}
        />
      </SpreadsheetTabs>
    </div>
  )
}

export default UploadWhitelist
